export const acceptedFormats = {
  'image/*': ['.jpg', '.jpeg', '.png'],
};
export const importAcceptedFormat = {
  'text/csv': ['.csv'],
};
